<template>
  <div id="app" :class="[$route.meta.menuFlag ? 'tth' : '']">
    <div class="headTopBox" v-show="$route.meta.menuFlag">
      <top-menu></top-menu>
      <div
        id="frame-nav-panel"
        style="
          opacity: 0;
          margin-left: 36px;
          position: relative;
          z-index: 100000000;
          width:calc(100% - 36px)
        "
      ></div>
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>

import TopMenu from "@/components/menu.vue";
export default {
  components: { TopMenu },
};
</script>
<style lang="less">
#app {
  font-family: PingFangSC, PingFangSC-Regular;
}
.animate__animated {
  -webkit-animation-duration: .3s !important;
  animation-duration: .3s !important;
  -webkit-animation-duration: var(--animate-duration);
  animation-duration: var(--animate-duration);
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.tth {
  padding-top: 64px;
}
.headTopBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100000000;
  background: #498add;
  height: 64px;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}
.filterBox{
  z-index: 100;
}
.backBtn {
  width: 1.12rem;
  height: 1.12rem;
  background: url("@/assets/back.svg") no-repeat;
  border-radius: 50%;
  background-size: cover;
  position: fixed;
  left: 0.5333333333rem;
  // bottom: 5.0133333333rem;
  top: 13.28rem;
  z-index: 200;
}
.loading {
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 500;
}
.noData {
  position: absolute;
  color: #999999;
  font-size: 0.32rem;
  line-height: 0.4533333333rem;
  width: 4rem;
  text-align: center;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  .bg {
    width: 4rem;
    height: 2.7733333333rem;
    background: url("@/assets/noData.png") no-repeat;
    background-size: cover;
  }
}
</style>